<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 491.587 491.587"
    xml:space="preserve"
  >
    <g>
      <path
        :fill="pathFill"
        width="80"
        height="80"
        d="M487.926,192.812l-49.498-49.498c-2.345-2.344-5.523-3.661-8.839-3.661s-6.495,1.317-8.839,3.661
		l-49.497,49.498c-4.882,4.882-4.882,12.796,0,17.678l8.839,8.839l-34.458,34.458l-81.67,3.889l162.09-162.09l12.374,12.374
		c3.064,3.064,7.497,4.323,11.711,3.327c4.216-0.995,7.616-4.103,8.986-8.213l28.284-84.853c1.497-4.492,0.328-9.443-3.02-12.792
		c-3.349-3.347-8.301-4.517-12.792-3.02l-84.853,28.284c-4.109,1.37-7.217,4.77-8.213,8.986c-0.995,4.216,0.264,8.647,3.327,11.711
		l12.374,12.375L192.531,265.468c-0.855,0.688-1.661,1.439-2.407,2.244c-0.096,0.104-0.19,0.209-0.282,0.315
		c-0.211,0.244-0.418,0.494-0.621,0.75l-13.69,13.69l3.889-81.671l31.038-31.038c18.815,6.724,40.203,2.224,54.729-12.303
		c9.916-9.916,15.377-23.1,15.377-37.123s-5.461-27.208-15.377-37.123c-9.916-9.916-23.1-15.377-37.123-15.377
		c-14.023,0-27.207,5.461-37.123,15.377c-14.527,14.527-19.026,35.915-12.303,54.729l-37.198,37.199
		c-3.984,3.987-6.315,9.284-6.561,14.869l-6.664,139.777l-22.9,22.901c-27.629-14.122-61.538-9.174-84.08,13.368
		C7.542,379.747,0,397.953,0,417.319c0,19.365,7.542,37.571,21.235,51.265s31.9,21.235,51.265,21.235
		c19.366,0,37.572-7.542,51.265-21.235c22.542-22.541,27.49-56.453,13.369-84.079l26.896-26.896c1.47-1.144,2.784-2.458,3.926-3.927
		l48.647-48.646l139.728-6.662c5.631-0.247,10.929-2.577,14.922-6.565l40.658-40.659l8.839,8.839c4.881,4.881,12.797,4.881,17.678,0
		l49.498-49.498c2.344-2.344,3.661-5.523,3.661-8.839S490.27,195.156,487.926,192.812L487.926,192.812z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    pathFill: {
      type: String,
      default: '#FFFFFF',
    },
  },
};
</script>
